var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 3.55154C34.6613 4.15385 33.2347 4.55308 31.7475 4.74692C33.2775 3.81 34.4453 2.33769 34.9943 0.563077C33.5678 1.43538 31.9927 2.05154 30.3142 2.39538C28.9597 0.916154 27.0292 0 24.9232 0C20.8372 0 17.5477 3.40154 17.5477 7.57154C17.5477 8.17154 17.5972 8.74846 17.7188 9.29769C11.583 8.99077 6.15375 5.97462 2.5065 1.38C1.86975 2.51308 1.49625 3.81 1.49625 5.20615C1.49625 7.82769 2.8125 10.1515 4.7745 11.4969C3.58875 11.4738 2.4255 11.1208 1.44 10.5646C1.44 10.5877 1.44 10.6177 1.44 10.6477C1.44 14.3262 3.99825 17.3815 7.353 18.0854C6.75225 18.2538 6.0975 18.3346 5.418 18.3346C4.9455 18.3346 4.4685 18.3069 4.02075 18.2054C4.977 21.2031 7.6905 23.4069 10.917 23.4785C8.406 25.4931 5.21775 26.7069 1.76625 26.7069C1.161 26.7069 0.5805 26.6792 0 26.6031C3.26925 28.7654 7.14375 30 11.322 30C24.903 30 32.328 18.4615 32.328 8.46C32.328 8.12538 32.3167 7.80231 32.301 7.48154C33.7658 6.41538 34.9965 5.08385 36 3.55154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4b9543e7ecdce1694dfb73ad571d60bb.svg";
export { ForwardRef as ReactComponent };